import {
  IWrapper,
  SubscriptionsResponse,
  SubscriptionDetailsResponse,
  SubscriptionPaymentResponse,
  SubscriptionPaymentDeferralPayload,
  SubscriptionPaymentDeferralResponse,
  ISubscription,
} from '../types';
import {PagingPayload} from '../constants';

/**
 * SubscriptionEndpoint class implements ISubscription interface
 */
class SubscriptionEndpoint implements ISubscription {
  readonly wrapper: IWrapper;

  /**
   * Constructor
   * @param {IWrapper} wrapper - The wrapper instance
   */
  constructor(wrapper: IWrapper) {
    this.wrapper = wrapper;
  }

  /**
   * Get subscriptions
   * @return {Promise<SubscriptionsResponse>}
   */
  public getSubscriptions(): Promise<SubscriptionsResponse> {
    return this.wrapper.get<SubscriptionsResponse>(
      '/v2/subscriptions',
      PagingPayload,
    );
  }

  /**
   * Get subscription details
   * @param {number} subscriptionId
   * @return {Promise<SubscriptionDetailsResponse>}
   */
  public getSubscriptionDetails(
    subscriptionId: number,
  ): Promise<SubscriptionDetailsResponse> {
    return this.wrapper.get<SubscriptionDetailsResponse>(
      `/v2/subscriptions/${subscriptionId}`,
    );
  }

  /**
   * Get subscription payments
   * @param {number} subscriptionId
   * @return {Promise<SubscriptionPaymentResponse>}
   */
  public getSubscriptionPayment(
    subscriptionId: number,
  ): Promise<SubscriptionPaymentResponse> {
    return this.wrapper.get<SubscriptionPaymentResponse>(
      `/v2/subscriptions/${subscriptionId}/payments`,
      PagingPayload,
    );
  }

  /**
   * Post subscription payment deferral
   * @param {number} idClientSubscription
   * @param {number} idPayment
   * @param params
   * @return {Promise<SubscriptionPaymentDeferralResponse>}
   */
  public putSubscriptionPaymentDeferral(
    idClientSubscription: number,
    idPayment: number,
    params: SubscriptionPaymentDeferralPayload,
  ): Promise<SubscriptionPaymentDeferralResponse> {
    return this.wrapper.put<SubscriptionPaymentDeferralResponse>(
      `/v2/subscriptions/${idClientSubscription}/payments/${idPayment}/defer`,
      params,
    );
  }
}

export default SubscriptionEndpoint;
